const DropForgeLaunchIcon = ({
  className,
}: {
  readonly className?: string | undefined;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.896 29.772"
    fill="currentColor"
    className={className}
  >
    <path d="M21.287,18.764c-0.005-0.004-0.011-0.01-0.016-0.016c7.692-7.961,9.384-17.333,8.351-18.381 C28.376-0.896,19.121,0.939,11.13,8.471c-0.006-0.006-0.014-0.013-0.021-0.021l-0.002-0.002C9.918,7.244,8.151,7.055,6.956,8.256 l-6.245,6.27c-1.194,1.2-0.849,2.589,0.77,3.089l0.8,0.244c1.54,0.475,3.695-0.023,4.93-1.109c0.367,1.27,1.22,2.402,2.283,3.48 c1.062,1.076,2.18,1.941,3.439,2.326c-1.1,1.221-1.625,3.367-1.172,4.912l0.235,0.801c0.478,1.625,1.863,1.99,3.079,0.811 l6.352-6.162c1.217-1.18,1.052-2.945-0.138-4.152L21.287,18.764z M20.195,5.067c1.203-1.187,3.141-1.175,4.327,0.027 c1.187,1.203,1.174,3.14-0.029,4.328c-1.202,1.186-3.14,1.173-4.326-0.029C18.979,8.192,18.993,6.253,20.195,5.067z" />
    <path d="M7.985,21.719c-0.977-0.988-1.803-2.014-2.361-3.104c-0.145,0.09-0.285,0.189-0.409,0.313 c-1.181,1.164-0.931,3.352,0.56,4.861c1.488,1.508,3.673,1.787,4.854,0.623c0.112-0.111,0.2-0.24,0.287-0.369 C9.885,23.475,8.918,22.664,7.985,21.719z" />
  </svg>
);

export default DropForgeLaunchIcon;
